import { TaskStatus } from '@dadohr/shared/domainTypes/experience';
import { TaskStatusChip } from '../../../../../../features/Experiences/components/TaskStatusChip';

export const TaskStatusChipV2 = ({ status }: { status: TaskStatus }) => {
  return (
    <TaskStatusChip status={status} color="light" variant="rounded" autoWidth />
  );
};
